<template>
  <div>
    <div class="filter container">
      <div class="cat">
        <el-row class="row">
          <el-col :span="2" class="col label">行业分类</el-col>
          <el-col :span="3" class="col">
            <el-select
              v-model="cat"
              placeholder="请选择"
              size="mini"
              @change="changeCat"
            >
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in industryArr"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2" :offset="1" class="col label">行业细分</el-col>
          <el-col :span="3" class="col">
            <el-select
              v-model="subCat"
              placeholder="请选择"
              size="mini"
              @change="changeSubCat"
            >
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in subCatArr"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="2" class="col label">投放渠道</el-col>
          <el-col :span="3" class="col">
            <el-select
              v-model="platform"
              placeholder="请选择"
              size="mini"
              @change="search"
            >
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in platformArr"
                :key="item.name"
                :label="item.title"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2" :offset="1" class="col label">设备信息</el-col>
          <el-col :span="3" class="col">
            <el-select
              v-model="system"
              placeholder="请选择"
              size="mini"
              @change="search"
            >
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in systemArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2" :offset="1" class="col label">广告位</el-col>
          <el-col :span="3" class="col">
            <el-select
              v-model="adType"
              placeholder="请选择"
              size="mini"
              @change="search"
            >
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in adslotArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
          <!-- <el-col :span="2" :offset="1" class="col label">素材样式</el-col>
          <el-col :span="3" class="col">
            <el-select
              v-model="system"
              placeholder="请选择"
              size="mini"
              @change="search"
            >
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in materialTypeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col> -->
        </el-row>
        <el-row class="row">
          <!-- <el-col :span="2" class="col label">时间：</el-col>
          <el-col :span="8" class="col">
            <el-radio-group v-model="duration" size="mini" @change="changeDate">
              <el-radio-button label="1" size="mini">近1天</el-radio-button>
              <el-radio-button label="7" size="mini">近7天</el-radio-button>
              <el-radio-button label="30" size="mini">近30天</el-radio-button>
              <el-radio-button label="90" size="mini">近90天</el-radio-button>
              <el-radio-button label="365" size="mini">近1年</el-radio-button>
            </el-radio-group>
          </el-col>
          <el-col :span="6" class="col date-picker" :offset="1"
            ><el-date-picker
              v-model="daterange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="yyyy-MM-dd"
              @change="changeDateRange"
            >
            </el-date-picker
          ></el-col> -->
          <el-col :span="2" class="col label">素材属性：</el-col>
          <el-col :span="5" class="col">
            <el-radio-group v-model="materialType" size="mini" @change="search">
              <el-radio-button label="" size="mini">不限</el-radio-button>
              <el-radio-button label="active" size="mini"
                >活跃素材</el-radio-button
              >
              <el-radio-button label="highQuality" size="mini"
                >优质素材</el-radio-button
              >
            </el-radio-group>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="main container">
      <div class="meta">
        <div>
          共筛选出{{ materialCount }}张素材
          <span v-if="!!updateTime">更新时间：{{ updateTime }}</span>
        </div>
        <div class="sort">
          <label>排序方式</label>
          <el-select
            v-model="order"
            placeholder="请选择"
            size="mini"
            @change="changeOrder"
          >
            <el-option
              v-for="item in orderArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="list">
        <MaterialItem
          v-for="item in materialArr"
          :material="item"
          :key="item.id"
        ></MaterialItem>
      </div>
    </div>
    <div class="pager">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="24"
        layout="prev, pager, next, jumper"
        :total="totalPage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import MaterialItem from "../components/MaterialItem";
export default {
  name: "AdMaterial",
  components: { MaterialItem: MaterialItem },
  mounted() {
    let session = this.$route.query["session"];
    if (!!session) {
      sessionStorage.setItem("session", session);
      sessionStorage.setItem("isLogin", "1");
    }
    let now = moment();
    let start = now.format("YYYY-MM-DD");
    let end = now.add(-30, "days");
    end = end.format("YYYY-MM-DD");
    this.daterange = [end, start];

    this.querySerchConfig();
    this.search();
  },
  data() {
    return {
      searchText: "",
      duration: "30",
      daterange: [],
      materialType: "", // 素材类型：优质素材或活跃素材
      materialCount: "0",
      updateTime: "",
      materialArr: [],
      currentPage: 1,
      totalPage: 10,
      platform: "",
      system: "",
      adType: "",
      subType: "",
      industryArr: [],
      platformArr: [],
      cat: "",
      subCat: "",
      subCatArr: [],
      order: "edTime",
      systemArr: [
        {
          label: "安卓",
          value: "Android",
        },
        {
          label: "iOS",
          value: "iOS",
        },
      ],
      adslotArr: [
        {
          label: "开屏",
          value: "splashad",
        },
        {
          label: "banner",
          value: "banner",
        },
        {
          label: "信息流",
          value: "flow",
        },
      ],
      materialTypeArr: [
        {
          label: "图片",
          value: "Android",
        },
        {
          label: "视频",
          value: "iOS",
        },
      ],
      orderArr: [
        {
          label: "最后展示时间",
          value: "edTime",
        },
        {
          label: "首次展示时间",
          value: "stTime",
        },
        {
          label: "展示数",
          value: "showNum",
        },
        {
          label: "投放天数",
          value: "showDayNum",
        },
        {
          label: "点击率",
          value: "clickRate",
        },
      ],
    };
  },
  methods: {
    search() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
      });
      let data = {
        page: this.currentPage - 1,
        cnt: 24,
        keyword: this.searchText,
        options: {
          stTime: this.daterange[0],
          edTime: this.daterange[1],
          l1Classification: this.cat,
          l2Classification: this.subCat,
          plaform: this.platform,
          system: this.system,
          subType: this.materialType,
          orderBy: this.order,
          adType: this.adType,
        },
      };
      console.log(data);
      this.$http
        .post("/fireeye/material/search", data)
        .then((res) => {
          let data = res.data;
          if (data.code != 0) {
            data = data.data;
            console.log(data);
            this.materialArr = data.list;
            this.materialCount = data.all;
            this.totalPage = parseInt(data.all);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    handleSizeChange() {},
    handleCurrentChange() {
      this.search();
    },
    querySerchConfig() {
      this.$http.get("/fireeye/material/search/config").then((res) => {
        console.log(res);
        let data = res.data;
        console.log(data);
        this.industryArr = data.data.industrys;
        this.platformArr = data.data.platforms;
      });
    },
    changeCat(cat) {
      this.$set(this, "subCat", "");
      if (cat == "") {
        this.currentPage = 1;
        this.search();
        return;
      }
      for (let item of this.industryArr) {
        if (item.name == cat) {
          this.subCatArr = item.tags;
          this.currentPage = 1;
          this.search();
        }
      }
    },
    changeSubCat() {
      this.currentPage = 1;
      this.search();
    },
    changeOrder() {
      this.currentPage = 1;
      this.search();
    },
    changeDateRange() {
      console.log(this.daterange, this.duration);
      if (this.daterange.length == 2) {
        let start = this.daterange[0];
        let end = this.daterange[1];
        let gap = 0 + end.replaceAll("-", "") - start.replaceAll("-", "");
        console.log(end.replaceAll("-", ""), start.replaceAll("-", ""), gap);
        this.duration = 0;
      }
      this.currentPage = 1;
      this.search();
    },
    changeDate() {
      console.log(this.daterange, this.duration);
      let now = moment();
      console.log(now);
      let start = now.format("YYYY-MM-DD");
      console.log(start);
      let end = now.add(-this.duration, "days");
      end = end.format("YYYY-MM-DD");
      this.daterange = [end, start];
      this.currentPage = 1;
      this.search();
    },
    clickRadio(value) {
      console.log(value, this.materialType);
      if (value == this.materialType) {
        this.materialType = "";
      } else {
        this.materialType = value;
      }
      this.currentPage = 1;
      this.search();
    },
  },
};
</script>

<style lang="less" scoped>
.filter {
  box-sizing: border-box;
  padding: 16px 24px;
  box-shadow: 0 0 5px #ddd;
  font-size: 12px;
  background: #ffffff;
  border-radius: 4px;
  line-height: 60px;

  .date-picker {
    padding-top: 2px;
  }

  .el-date-editor--daterange {
    width: 220px;
  }

  .label {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #212121;
  }
  .row {
    height: 60px;
    line-height: 60px;
    overflow: hidden;

    .col {
      text-align: left;
    }
  }
  .radio-group {
    .radio {
      white-space: nowrap;
      background: #fff;
      border: 1px solid #dcdfe6;
      font-weight: 500;
      border-left: 0;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      position: relative;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      border-radius: 0;
      padding: 7px 15px;
      font-size: 12px;
    }
    .radio:first-child {
      border-left: 1px solid #dcdfe6;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    .radio:last-child {
      border-left: 1px solid #dcdfe6;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
    .radio.active {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      box-shadow: -1px 0 0 0 #409eff;
    }
    .radio.active:hover {
      color: #fff;
    }
    .radio:hover {
      color: #409eff;
    }
  }
}
.main {
  margin-top: 36px;

  .meta {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    height: 60px;
    line-height: 60px;

    .sort {
      label {
        padding-right: 20px;
      }
      .el-select {
        display: inline-block;
      }
    }
  }
  .list {
    margin-right: -15px;
    display: flex;
    flex-wrap: wrap;
  }
}
.pager {
  margin: 30px 0 60px;
}
</style>